import React, {Component} from "react"
import {match as Match} from "react-router"
import {IndexRedirect, NestedRoute, PartialRoute, withPartialRoute} from "@irati/utils/history/routing"

import AppContainer from "@irati/ui/src/AppContainer"
import {HasPermissionTo} from "@irati/utils/permissions"
import mainTheme from "@irati/ui/src/global/theme"

import DealInfo from "../../containers/DealInfo"
import Deals from "../../containers/Deals"
import HomePage from "../../containers/HomePage"
import Account from "./account"
import PerksContainer from "../containers/PerksContainer"
import DealSuccess from "../../containers/DealSuccess"
import DealRedemptionError from "../../containers/DealRedemptionError"
import DealPayment from "../../containers/DealPayment"
import DealSelectProducts from "../../containers/DealSelectProducts"
import DealPaymentRedirectLanding from "../../containers/DealPaymentRedirectLanding"
import TagLandingPage from "../../containers/Tag"

interface InfoProps {
  match: Match
}

const Info = ({match: {url}}: InfoProps) => (
  <>
    <NestedRoute match={url} exact path="/:urlSlug" title="Deal" component={DealInfo} />
    <NestedRoute match={url} exact path="/:urlSlug/redeem" component={DealSelectProducts} title="Redeem" />
    <NestedRoute match={url} exact path="/:urlSlug/pay" title="Payment" component={DealPayment} />
    <NestedRoute match={url} path="/:urlSlug/error/:checkoutId/:paymentOrderId" title="Redemption error" component={DealRedemptionError} />
    <NestedRoute
      match={url}
      path="/:urlSlug/payment-redirect/:checkoutId"
      title="Payment complete"
      component={DealPaymentRedirectLanding} />
    <NestedRoute match={url} path="/:urlSlug/success/:redemptionId" title="Deal Redeemed" component={DealSuccess} />
  </>
)

interface PerksClientProps {
  path: string,
  location: Location
}

class PerksClient extends Component<PerksClientProps> {
  render() {
    const {path, location} = this.props

    const isPerksAccount = location.pathname.includes("/perks/account")

    return (
      <AppContainer mainBackground={isPerksAccount && mainTheme.colors.greys.white}>
        <HasPermissionTo permissions="perks">
          <PerksContainer>
            <NestedRoute match={path} path="/account" component={Account} />
            <NestedRoute match={path} path="/categories/:category?" title="Deals" component={Deals} />
            <PartialRoute match={path} path="/info" component={Info} />
            <PartialRoute match={path} path="/discover" title="Home" component={HomePage} />
            <NestedRoute match={path} path="/tag/:tagIdOrUrl" title="Loading tag..." component={TagLandingPage} />
            <IndexRedirect match={{url: path}} to="/discover" />
          </PerksContainer>
        </HasPermissionTo>
      </AppContainer>
    )
  }
}

export default withPartialRoute(PerksClient)
